export default __webpack_public_path__ + "static/unicef-light.988f54b5.svg";